<template>
  <div class="wrapper" v-remove-containing-element>
    <ComponentTree
      v-for="childNode in appliedChildren"
      :key="childNode?.lastUpdate"
      :children="childNode?.children"
      :__componentType="childNode?.componentType"
      :__id="childNode?.nodeUUID"
      :expression="childNode?.expression"
      :name="childNode?.name"
      :options="childNode?.options"
      :parameters="parameters"
      :node="childNode"
      :nodeUUID="childNode?.nodeUUID"
      :parentNodeUUID="childNode?.parentNodeUUID"
      :paused="childNode?.paused"
      :propsData="childNode?.propsData"
      v-bind="getNodeBindings(childNode)"
    >
      <slot></slot>
    </ComponentTree>
  </div>
</template>

<script>
export default {
  // ...resto código
}
</script>

<style scoped>
.wrapper {
  display: contents;
}
</style>

<script>
import { getTreeBindings } from "@/components/treeBindings.js";

export default {
  props: ["children", "cssClass", "cssStyle", "parameters", "byName"],
  name: "ChildrenTree",
  methods: {
    getNodeBindings(node) {
      return getTreeBindings(node, this.parameters, { childNode: node })
    }
  },
  mounted() {
    const container = this.$el
    const parent = container.parentNode
    console.log({ container, parent })
  },
  computed: {
    appliedChildren() {
      let a = this.children ? this.children : this.$parent.children
      if (!Array.isArray(a)) a = [a]

      if (!this.$parent.componentType) {
        return []
      }

      if (this.byName) a = this._.filter(a, el => el.name === this.byName)

      return a
    }
  },
  render(h) {
    // Aquí devolvemos array de hijos sin wrapper, eliminando el div is_v2
    return this.appliedChildren.map(childNode =>
      h(
        'ComponentTree',
        {
          key: childNode?.lastUpdate,
          props: {
            children: childNode?.children,
            __componentType: childNode?.componentType,
            __id: childNode?.nodeUUID,
            expression: childNode?.expression,
            name: childNode?.name,
            options: childNode?.options,
            parameters: this.parameters,
            node: childNode,
            nodeUUID: childNode?.nodeUUID,
            parentNodeUUID: childNode?.parentNodeUUID,
            paused: childNode?.paused,
            propsData: childNode?.propsData,
          },
          attrs: this.getNodeBindings(childNode),
          scopedSlots: this.$scopedSlots,
        },
        this.$slots.default
      )
    )
  }
}
</script>
